// Adding React to allow us to run tests with this component in Platform
// eslint-disable-next-line no-unused-vars
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.module.less';

const ToolbarButton = ({ onClick, isDisabled, isActive, label, children }) => {
  return (
    <button
      type='button'
      aria-label={label}
      disabled={isDisabled}
      onClick={onClick}
      className={classNames(styles.toolbarButton, {
        [styles.disabled]: isDisabled,
        [styles.active]: isActive,
      })}
    >
      <div className={styles.buttonText}>{children}</div>
    </button>
  );
};

ToolbarButton.propTypes = {
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  isActive: PropTypes.bool,
  label: PropTypes.string,
  children: PropTypes.node,
};

export default ToolbarButton;
